/** See `src/i18n/locales/en/roles.ts`. */
export const roles = {
  form: {
    person: 'Personne',
    choose: 'Choisir…',
    grant: 'Accorder {{label}}',
    revoke: 'Révoquer {{label}}',
    back: 'Retour',
  },
  company: {
    title: 'Administrateurs de l’entreprise',
    lead: 'Un administrateur d’entreprise gère les informations propres, les départements, les membres et le provisionnement de cette entreprise. L’octroi et la révocation sont audités.',
    label: 'administrateur d’entreprise',
    rowsLabel: 'les membres de l’entreprise',
  },
  department: {
    title: 'Administrateurs de département (coach)',
    lead: 'Un administrateur de département consulte les membres et les agrégats de ce département, et — selon la règle d’accès individuel — les statistiques individuelles que couvre sa base de consentement. L’octroi et la révocation sont audités.',
    label: 'administrateur de département',
    rowsLabel: 'les membres du département',
  },
  admins: {
    title: 'Administrateurs de la plateforme',
    lead: 'Un administrateur de plateforme détient chaque autorité portée. La cible d’une nomination doit avoir une connexion et être une identité primaire ; le dernier administrateur ne peut pas être révoqué.',
    name: 'Nom',
    email: 'E-mail',
    retire: 'Révoquer',
    rowsLabel: 'les administrateurs',
    searchPeople: 'Rechercher des personnes',
    searchPlaceholder: 'Nom ou e-mail',
    person: 'Personne',
    choose: 'Choisir…',
    noEligible: 'Aucune personne éligible ne correspond — elle doit avoir sa propre connexion.',
    appoint: 'Nommer',
    usersLabel: 'les utilisateurs de la plateforme',
  },
} as const;
